export class BankAccount {
	billingFirstName: string = '';
	billingLastName: string = '';
	billingName: string = '';
	bankAccountType: string = '';
	bankRoutingNumber: string = '';
	bankAccountNumber: string = '';
	billingZipcode: string = '';
}
